import { ISODateStringToUTCDate } from './ISODateStringToUTCDate';

export const isTodayOrFuture = (dateString: string) => {
  const date = ISODateStringToUTCDate(dateString);
  const today = new Date();
  today.setUTCHours(0, 0, 0, 0);
  return date >= today;
};
